import axios from 'axios';

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

const server = isLocalhost ? `${window.location.protocol}//${window.location.hostname}:3500` : window.location.origin;

const Api = axios.create({ baseURL: server,  validateStatus: status => status < 500 });

export const getTeeTimes = params => Api.get('/teetimes', { params })

export const createPreReservation = params => Api.get('/createPreReservation', { params })






// WEBPACK FOOTER //
// ./src/services/api.js